export var MuiDrawer = {
  styleOverrides: {
    paper: function paper(_ref) {
      var theme = _ref.theme;
      return {
        background: theme.background.secondary
      };
    }
  }
};
//# sourceMappingURL=MuiDrawer.js.map